import { render, staticRenderFns } from "./BracketFinalStage.vue?vue&type=template&id=125b0136&"
import script from "./BracketFinalStage.vue?vue&type=script&lang=js&"
export * from "./BracketFinalStage.vue?vue&type=script&lang=js&"
import style0 from "./BracketFinalStage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports